import {
    limit as limitFirebase,
    orderBy,
    where,
} from "firebase/firestore";
import { Collection, WhereField } from '../../shared/constants';
import { isNullOrEmpty } from '../../shared/utils';
import { deleteDoc, getAllDocsByQueries, getCountByQueries } from './collectionBaseWorker';

export const getAllMessagesByQueries = async ({
    clienteId,
    status,
    referenceId,
    limit
}) => {
    const items = await getAllDocsByQueries({
        collection: Collection.MESSAGES, queries: [
            !isNullOrEmpty(clienteId) && where(WhereField.PARKID, "==", clienteId),
            !isNullOrEmpty(status) && where(WhereField.CURRENT_STATUS, "==", status),
            !isNullOrEmpty(referenceId) && where(WhereField.REFERENCE_ID, "==", referenceId),
            orderBy(WhereField.CREATED_AT, "desc"),
            limitFirebase(parseInt(limit ?? 0))
        ]
    })
    return items
}

export const getCountMessagesByParkIdAndDates = async ({ estacionamentoId, startDate, endDate }) => {
    return await getCountByQueries({
        collection: Collection.MESSAGES,
        queries: [
            where(WhereField.PARKID, "==", estacionamentoId),
            where(WhereField.CREATED_AT, '>=', startDate),
            where(WhereField.CREATED_AT, '<=', endDate)
        ]
    })
}

export const deleteMessageById = async ({ id }) => {
    return await deleteDoc({ collection: Collection.MESSAGES, id: id })
}